export enum CallStatusEnum{
  WAITING = 'WAITING',
  CLOSED_BY_USER='CLOSED_BY_USER' ,
  CLOSED_BY_ADMIN = "CLOSED_BY_ADMIN",
  CLOSED_BY_SYSTEM= "CLOSED_BY_SYSTEM",
}
